export enum E_BANNER_POSITION {
  LEFT = "LEFT",
  TOP_RIGHT = "TOP_RIGHT",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  MOBILE = "MOBILE",
}

export const BannerPositionLabels: Record<E_BANNER_POSITION, string> = {
  [E_BANNER_POSITION.LEFT]: "ซ้าย",
  [E_BANNER_POSITION.TOP_RIGHT]: "บนขวา",
  [E_BANNER_POSITION.BOTTOM_RIGHT]: "ล่างขวา",
  [E_BANNER_POSITION.MOBILE]: "มือถือ",
};
